<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container big-container">
        <div class="row mt-20">
          <div class="col-sm-8">
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToExport"
                  class="btn btn-primary pull-left"
                  @click="openExportModal()"
                >
                  <span><i class="ic-download"></i></span>Export
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    {{ rentalLabel }} &amp; {{ airportLabel }} Bookings
                    <span><i class="ic-booking-history"></i></span>
                  </h2>
                  <p>Manage and view all transactions.</p>
                </div>
              </div>
            </div>
          </div>
          <!-- /.col-sm-8 -->
          <div class="col-sm-4 text-right">
            <div class="form-group">
              <div class="btn-group" role="group" aria-label="...">
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'all' }"
                  @click="getAll('all')"
                >
                  All
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'daily' }"
                  @click="getAll('daily', true)"
                >
                  Daily
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'weekly' }"
                  @click="getAll('weekly', true)"
                >
                  Weekly
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'monthly' }"
                  @click="getAll('monthly', true)"
                >
                  Monthly
                </button>
              </div>
            </div>
          </div>
          <!-- /.col-sm-4 -->
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container big-container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Reservation Code"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <!-- /.row -->
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive table-manage">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="text-center">Type</th>
                    <th>Code</th>
                    <!-- <th>Booker</th> -->
                    <th>Passenger</th>
                    <th>Vehicle</th>
                    <th>Pick-Up</th>
                    <th>Drop-Off</th>
                    <!-- <th>Payment</th> -->
                    <th class="text-center">Progress</th>
                    <th class="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="detail-row" v-for="item in items" :key="item.id">
                    <td class="text-center">
                      <strong>
                        <i
                          v-if="
                            isAirportTransfer(item.serviceType) &&
                            item.pickUpLocation.isAirport
                          "
                          class="ic-flight-icon"
                        ></i>
                        <i
                          v-else-if="
                            isAirportTransfer(item.serviceType) &&
                            item.dropOffLocation.isAirport
                          "
                          class="ic-flight-departure-icon"
                        ></i>
                        <i
                          class="ic-car-alt"
                          v-else-if="
                            isAirportTransfer(item.serviceType) &&
                            !item.pickUpLocation.isAirport &&
                            !item.dropOffLocation.isAirport
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 1200 1200"
                          >
                            <path
                              fill="currentColor"
                              d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                            />
                          </svg>
                        </i>
                        <i v-else class="ic-time"></i>
                      </strong>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0)"
                        class="view-detail-link"
                        @click.prevent="open(item)"
                      >
                        {{ item.code }}
                      </a>
                    </td>
                    <!-- <td>
                      <strong>{{ item.booker.companyName }}</strong>
                      <span class="new-line">
                        {{ item.booker.customerTitle }}.
                        {{ item.booker.customerName }}
                      </span>
                    </td> -->
                    <td>
                      <!-- <strong>{{ item.passenger.companyName }}</strong> -->
                      <span class="new-line">
                        {{
                          item.passenger.customerTitle
                            ? `${item.passenger.customerTitle}.`
                            : ""
                        }}
                        {{ item.passenger.customerName }}
                      </span>
                    </td>
                    <td>
                      {{ item.className }}
                      <span v-if="item.vehicle">
                        <span class="new-line">
                          {{ item.vehicle.factoryName }}
                          {{ item.vehicle.brandName }}
                        </span>
                        <span class="new-line">
                          ({{ item.vehicle.plateNumber }})
                        </span>
                      </span>
                    </td>
                    <td>
                      {{ formatDate(item.pickUpDate) }}
                      <strong>{{ formatTime(item.pickUpDate) }}</strong>
                      <span class="utc-style"
                        >({{ item.pickUpDate.offsetName }})</span
                      >
                    </td>
                    <td>
                      {{ formatDate(item.dropOffDate) }}
                      <strong>{{ formatTime(item.dropOffDate) }}</strong>
                      <span class="utc-style"
                        >({{ item.dropOffDate.offsetName }})</span
                      >
                    </td>
                    <!-- <td
                      :class="{
                        '--green35': item.paymentStatus === 'Complete' || item.paymentStatus === 'Refunded',
                        'sts-danger': item.paymentStatus === 'Unpaid' || item.paymentStatus === 'RefundRequested',
                      }"
                    >
                      {{ item.paymentStatus === 'Complete' ? 'Completed' : humanize(item.paymentStatus) }}
                    </td> -->
                    <td class="text-center">
                      <span
                        :class="{
                          'sts_job-open': item.progress === 'Open',
                          'sts_job-run': item.progress === 'Run',
                          'sts_job-done': item.progress === 'Done',
                          'sts_job-closed': item.progress === 'Close',
                          'sts_job-aborted': item.progress === 'Abort',
                          'sts_job-rescue_operation':
                            item.progress === 'RescueOperation',
                          'sts_job-under-review':
                            item.progress === 'UnderReview',
                        }"
                      ></span>
                    </td>
                    <td class="text-right">
                      <span v-if="item.buyingRate"
                        >{{ item.buyingRate.currencyCode }}
                        {{
                          $currencyFormat(
                            item.buyingRate.currencyCode,
                            item.buyingRate.grandTotal
                          )
                        }}</span
                      >
                      <span v-else class="sts-danger">N/A</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- /.row -->
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
        <!-- /.row -->
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="exportmodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Export Report</h4>
                <h6>Please fill all information below.</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <form action="#" id="vueform" role="form">
                    <div class="form-group">
                      <label class="required">Reservation Range</label>
                      <VueCtkDateTimePicker
                        id="mutation-start"
                        v-model="exportParam.reservationRange"
                        color="#025BC5"
                        format="YYYY-MM-DD"
                        formatted="LL"
                        range
                        auto-close
                        only-date
                        no-label
                        no-header
                        no-button
                        no-button-now
                      />
                    </div>
                    <!-- <div class="form-group">
                      <label class="required">Payment Status</label>
                      <v-select
                        class="v-search-select"
                        placeholder=""
                        label="text"
                        v-model="exportParam.paymentStatus"
                        :options="paymentStatus"
                        :clearable="false"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.value"
                      >
                        <template #search="{ attributes, events }">
                          <input
                            class="vs__search"
                            name="paymentStatus"
                            :required="!exportParam.paymentStatus"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-select>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.paymentStatus"
                        v-text="validationErrors.paymentStatus"
                      ></small>
                    </div> -->
                    <div class="form-group">
                      <label class="required">Progress Type</label>
                      <v-select
                        class="v-search-select"
                        placeholder=""
                        label="text"
                        v-model="exportParam.progressType"
                        :options="progressTypes"
                        :clearable="false"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.value"
                      >
                        <template #search="{ attributes, events }">
                          <input
                            class="vs__search"
                            name="progressType"
                            :required="!exportParam.progressType"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-select>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.progressType"
                        v-text="validationErrors.progressType"
                      ></small>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <label class="required">Sort</label>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <v-select
                                class="v-search-select"
                                placeholder=""
                                label="text"
                                v-model="exportParam.sortBy"
                                :options="sortBy"
                                :clearable="false"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.value"
                              >
                                <template #search="{ attributes, events }">
                                  <input
                                    class="vs__search"
                                    name="sortBy"
                                    :required="!exportParam.sortBy"
                                    v-bind="attributes"
                                    v-on="events"
                                  />
                                </template>
                              </v-select>
                              <small
                                class="form-text text-danger"
                                v-if="validationErrors.sortBy"
                                v-text="validationErrors.sortBy"
                              ></small>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <div class="d-flex">
                                <label class="cursor-pointer mb-0 mt-5">
                                  <input
                                    type="radio"
                                    class="control-radio"
                                    value="true"
                                    :checked="exportParam.isAsc == true"
                                    v-model="exportParam.isAsc"
                                  />
                                  <span
                                    class="pl-5 font-weight-normal v-align-middle"
                                    >Oldest</span
                                  >
                                </label>
                                <label class="cursor-pointer mb-0 mt-5 pl-20">
                                  <input
                                    type="radio"
                                    class="control-radio"
                                    value="false"
                                    :checked="exportParam.isAsc == false"
                                    v-model="exportParam.isAsc"
                                  />
                                  <span
                                    class="pl-5 font-weight-normal v-align-middle"
                                    >Newest</span
                                  >
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Filter</label>
                      <v-select
                        class="v-search-select"
                        placeholder=""
                        label="text"
                        v-model="exportParam.filterType"
                        :options="filters"
                        :clearable="false"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.value"
                      >
                      </v-select>
                    </div>
                    <div
                      class="form-group"
                      v-if="exportParam.filterType === 'Provider'"
                    >
                      <label>Company's {{ exportParam.filterType }}</label>
                      <multiselect
                        v-model="exportParam.providers"
                        :options="providers"
                        :multiple="true"
                        :close-on-select="false"
                        :limit="1"
                        placeholder="Select provider"
                        label="name"
                        track-by="id"
                      ></multiselect>
                    </div>
                    <div
                      class="form-group"
                      v-if="exportParam.filterType === 'Booker'"
                    >
                      <label>Company's {{ exportParam.filterType }}</label>
                      <multiselect
                        v-model="exportParam.bookers"
                        :options="companies"
                        :multiple="true"
                        :close-on-select="false"
                        :limit="1"
                        placeholder="Select booker"
                        label="name"
                        track-by="id"
                      ></multiselect>
                    </div>
                    <div
                      class="form-group"
                      v-if="exportParam.filterType === 'Passenger'"
                    >
                      <label>Company's {{ exportParam.filterType }}</label>
                      <multiselect
                        v-model="exportParam.passengers"
                        :options="companies"
                        :multiple="true"
                        :close-on-select="false"
                        :limit="1"
                        placeholder="Select passenger"
                        label="name"
                        track-by="id"
                      ></multiselect>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click.prevent="exportToExcel()"
                      >
                        Export
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import providerReportService from "@/services/shop/report/providerReportService.js";
import providerService from "@/services/master/provider/providerService.js";
import companyService from "@/services/master/company/companyService.js";

export default {
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToExport: function () {
      return this.allPermissions.includes("Export");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      validationErrors: {
        paymentStatus: null,
        progressType: null,
        sortby: null,
        filter: null,
      },
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      exportParam: {
        provider: null,
        reservationRange: null,
        paymentStatus: null,
        progressType: null,
        sortBy: null,
        isAsc: null,
        filterType: null,
        providers: [],
        bookers: [],
        passengers: [],
      },
      filters: [],
      providers: [],
      companies: [],
      paymentStatus: [],
      progressTypes: [],
      sortBy: [],
      rentalLabel: null,
      airportLabel: null,
      allPermissions: [],
      items: [],
      // period: "daily",
      period: "all",
      isLoading: false,
      msg: "Please wait",
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );
    this.rentalLabel = this.$helper.extractSetting(
      publicSettings,
      "RentalLabel",
      "Hourly"
    );
    this.airportLabel = this.$helper.extractSetting(
      publicSettings,
      "AirportLabel",
      "Airport"
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      this.paymentStatus = [
        { value: "All", text: "All" },
        { value: "Complete", text: "Completed" },
        { value: "Unpaid", text: "Unpaid" },
        { value: "RefundRequested", text: "Refund Requested" },
        { value: "Refunded", text: "Refunded" },
        { value: "RefundRejected", text: "Refund Rejected" },
      ];

      this.progressTypes = [
        { value: "All", text: "All" },
        { value: "Open", text: "Open" },
        { value: "Run", text: "Run" },
        { value: "Done", text: "Done" },
        { value: "Close", text: "Close" },
        { value: "Abort", text: "Abort" },
        { value: "RescueOperation", text: "Rescue" },
      ];

      this.sortBy = [
        { value: "ReservationDate", text: "Reservation Date" },
        { value: "PickUpDate", text: "Pick-Up Date" },
        { value: "DropOffDate", text: "Drop-Off Date" },
      ];

      this.filters = [
        { value: "None", text: "None" },
        { value: "Provider", text: "Provider" },
        // { value: "Booker", text: "Booker" },
        // { value: "Passenger", text: "Passenger" },
      ];

      this.getProviders();
      this.getCompanies();
      await this.getAll(this.period);
    }
  },
  updated() {
    this.$helper.collapseMenu("booking-history");
    this.$helper.setNavigationClass("provider-report-link");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll(this.period);
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll(this.period);
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll(this.period);
    },
    async getProviders() {
      this.providers = await providerService.getAllActive();
    },
    async getCompanies() {
      this.companies = await companyService.getAllActive();
    },
    async getAll(period, clear = false) {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        if (clear) this.table.pageNumber = 1;
        this.isLoading = true;
        this.period = period;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        filter += `&data=${this.period};`;
        const response = await providerReportService.getAll(filter);
        if (response.data == null) {
          this.$notification.error("No reservation found", { title: "Error" });
          this.items = [];
          this.table.totalPages = 1;
          this.table.totalRecords = response.totalRecords;
          return;
        }
        this.items = response.data.items;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    open(reservation) {
      const pathUrl = `/reservation/inquiry/`;
      const routeData = this.$router.resolve({
        path: pathUrl + reservation.id,
      });
      window.open(routeData.href, "_blank");
    },
    openExportModal() {
      const thisMonth = new Date();
      const selectedDate = `${thisMonth.getFullYear()}-${
        thisMonth.getMonth() + 1
      }-${thisMonth.getDate()}`;
      this.exportParam.reservationRange = {
        start: selectedDate,
        end: selectedDate,
      };
      this.exportParam.progressType = "All";
      this.exportParam.paymentStatus = "All";
      this.exportParam.sortBy = "ReservationDate";
      this.exportParam.isAsc = true;
      this.exportParam.filterType = "None";
      this.exportParam.providers = [];
      this.exportParam.bookers = [];
      this.exportParam.passengers = [];
      $(this.$refs.exportmodal).modal({ backdrop: "static", keyboard: false });
    },
    async exportToExcel() {
      try {
        this.isLoading = true;
        const startDates = this.exportParam.reservationRange.start.split("-");
        const endDates = this.exportParam.reservationRange.end.split("-");
        const request = {
          filterType: this.exportParam.filterType,
          filterIds: [],
          providers: [],
          startDate: {
            year: Number(startDates[0]),
            month: Number(startDates[1]),
            day: Number(startDates[2]),
          },
          endDate: {
            year: Number(endDates[0]),
            month: Number(endDates[1]),
            day: Number(endDates[2]),
          },
          paymentStatus: this.exportParam.paymentStatus,
          progressType: this.exportParam.progressType,
          sortBy: this.exportParam.sortBy,
          isAsc: this.exportParam.isAsc,
        };
        switch (request.filterType) {
          case "Provider":
            request.filterIds = this.exportParam.providers.map((x) => x.id);
            break;
          case "Booker":
            request.filterIds = this.exportParam.bookers.map((x) => x.id);
            break;
          case "Passenger":
            request.filterIds = this.exportParam.passengers.map((x) => x.id);
            break;
        }
        const response = await providerReportService.exportToExcel(request);
        if (response.data.isReportExist) {
          const link = document.createElement("a");
          link.href = `data:application/octet-stream;charset=utf-8;base64,${response.data.content}`;
          link.target = "_blank";
          link.download = `${response.data.name}.xlsx`;
          link.click();
        } else {
          this.$notification.warning("Report not found", { title: "Warning" });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(datetime) {
      return (
        datetime.stringShortMonth +
        ", " +
        datetime.stringDate +
        " " +
        datetime.year
      );
    },
    formatTime(datetime) {
      return datetime.stringHour + ":" + datetime.stringMinute;
    },
    isAirportTransfer(serviceType) {
      return serviceType.toLowerCase() === "airporttransfer";
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/report/ReportProvider.vue